<template>
  <div id="linkedin_activity">
    <ContainerInfoItem
      source="linkedin_activity_graph"
      title="Linkedin Activity"
      :description="range.label"
      height="fit-content"
    >
      <SkeletonLoader v-if="isLoading" :page="loaderPages.CHART" />

      <LineChart
        v-else-if="chartCategories && chartData"
        id="linkedin_activity"
        :categories="chartCategories"
        :series-data="chartData"
      />

      <EmptyScreen
        v-else
        source="linkedin_activity_graph"
        text="No data found!"
        :type="emptyScreenTypes.CHART_AND_TABLE"
      />
    </ContainerInfoItem>
  </div>
</template>

<script setup>
import { computed, ref, watchEffect } from "vue";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import { emptyScreenTypes } from "@/src/constants/searchConstants.js";
import { processLineChartData } from "@/src/utils/chartUtils.js";
import store from "@/src/store/index.js";
import AnalyticService from "@/src/api/AnalyticService.js";
import EmptyScreen from "@/src/components/EmptyScreen.vue";
import LineChart from "@/src/components/charts/LineChart.vue";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";
import ContainerInfoItem from "@/src/components/info_components/ContainerInfoItem.vue";
import { useAnalyticsRefresh } from "@/src/composables/useAnalyticsRefresh.js";

const range = computed(() => store.getters["analytics/getRange"]);
const chartCategories = ref(null);
const chartData = ref(null);
const isLoading = ref(false);

const processLinkedinActivityData = (data) => {
  return processLineChartData(data, {
    dataKey: "date",
    metrics: [
      { key: "invites_sent", label: "Invites Sent" },
      { key: "messages_sent", label: "Messages Sent" },
      { key: "inmails_sent", label: "InMails Sent" },
      { key: "message_replies", label: "Message Replies" },
      { key: "inmail_replies", label: "InMail Replies" },
      { key: "total_replies", label: "Total Replies" },
    ],
  });
};

const toFetchLinkedinCampaign = async () => {
  try {
    isLoading.value = true;

    const params = {
      start_time: range.value?.start,
      end_time: range.value?.end,
    };

    const response = await AnalyticService.V2.fetchLinkedinCampaign(params);
    if (response?.success && response?.data?.data) {
      const { categories, seriesData } = processLinkedinActivityData(
        response?.data?.data,
      );

      chartCategories.value = categories;
      chartData.value = seriesData;
    } else {
      chartCategories.value = null;
      chartData.value = null;
    }
  } catch (error) {
    console.log("An error occurred while fetching linkedin campaign: ", error);
    chartCategories.value = null;
    chartData.value = null;
  } finally {
    isLoading.value = false;
  }
};

watchEffect(() => {
  if (range.value) toFetchLinkedinCampaign();
});

useAnalyticsRefresh(toFetchLinkedinCampaign, [range]);
</script>
